import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthenticationService } from "./services/authentication.service";

@Injectable()
export class InvalidSessionInterceptor implements HttpInterceptor {
  private errors = [401, 403];

  constructor(private authenticationService: AuthenticationService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (this.errors.indexOf(err.status) !== -1) {
          this.authenticationService.logout();
        }

        return throwError(() => err);
      })
    );
  }
}
